import { DayPicker } from 'react-day-picker';
import { ComponentProps, FC } from 'react';
import { es } from 'date-fns/locale';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

import './calendario.css';

type PropsCalendario = ComponentProps<typeof DayPicker>;

const Calendario: FC<PropsCalendario> = ({
  classNames,
  showOutsideDays = true,
  ...props
}) => {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      locale={es}
      classNames={{
        root: 'calendario',
        month: '', // Reseteo de estilos
        caption: 'calendario__cabecera',
        nav: 'calendario__nav',
        nav_button: 'calendario__botonesNav',
        nav_button_previous: 'calendario__botonPrevio',
        nav_button_next: 'calendario__botonSiguiente',
        caption_label: 'calendario__nombreMes',
        months: 'calendario__mesesContainer',
        head_row: 'calendario__filaCabecera',
        head_cell: 'calendario__celdaCabecera',
        row: 'calendario__fila',
        day: 'calendario__dia',
        cell: 'calendario__celda',
        day_selected: 'calendario__seleccionado',
        day_range_middle: 'calendario__entreRangos',
        day_outside: `rdp-day_outside calendario__diaFueraDeMes`,
        ...classNames,
      }}
      components={{
        IconLeft: () => (
          <ChevronLeftIcon height={'1.25rem'} width={'1.25rem'} />
        ),
        IconRight: () => (
          <ChevronRightIcon height={'1.25rem'} width={'1.25rem'} />
        ),
      }}
      {...props}
    />
  );
};

export default Calendario;
